import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { onTimeChange } from 'src/app/utils/utils.common';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { InvoiceService } from 'src/app/services/core/services/invoices/invoice.service';
import { CustomersService } from 'src/app/services/core/services/customers/customers.service';
import { ProductService } from 'src/app/services/core/services/product-services/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-add-invoice',
  templateUrl: './add-invoice.component.html',
  styleUrls: ['./add-invoice.component.css']
})
export class AddInvoiceComponent implements OnInit {

  invoiceForm!: FormGroup;
  submitted = false;
  lineItemSubmitted = false;
  invoiceId: any;
  user: any;
  customers: any;
  productItems:any;
  preCustomers = {};
  selectedCompany:any = '';
  companies:any;

  constructor(
    private companyService: CompanyService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private productService: ProductService,
    private customerService: CustomersService,
    private invoiceServices: InvoiceService,
    private sharedDataService: SharedDataService,
    private fb: FormBuilder) { }

  ngOnInit(): void {

    this.activatedRoute.params
      .pipe(untilDestroyed(this)).subscribe((params) => {
        this.invoiceId = params["id"];
        if (this.invoiceId) {
          this.getInvoiceId();

        }
      }
      );

    this.invoiceForm = this.fb.group({
      CustomerRef: this.fb.group({
        value: ['', Validators.required]
      }),
      BillEmail: this.fb.group({
        Address: ['', Validators.required]
      }),
 
      DueDate: [this.invoiceId ? '' : moment().add(1, 'month').toISOString()],
      Line: this.fb.array([
        this.createLineItem()
      ]),
      reference: this.fb.group({
        name : [''],
        id:['']
      }),
    });
    this.getUser()
    this.getCompanies();
  }

  createLineItem(): FormGroup {
    return this.fb.group({
      DetailType: ['SalesItemLineDetail', Validators.required],
      Amount: [0, [Validators.required, Validators.min(0.01)]],
      Description: ['', Validators.required],

      SalesItemLineDetail: this.fb.group({
        ItemRef: this.fb.group({
          value: ['', Validators.required],
        }),
        ServiceDate: [''],
        Qty: [1, [Validators.required, Validators.min(1)]],
        Sku: [{ value: '0', disabled: true }],
        UnitPrice: ['', Validators.required],
      })
    });
  }

  get lineItems() {
    return this.invoiceForm.get('Line') as FormArray;
  }

  get lineItemsGroups() {
    return this.lineItems.controls as FormGroup[];
  }

  get reference(): FormGroup {
    return this.invoiceForm.get('reference') as FormGroup;
  }

  get BillEmail(){
    return this.invoiceForm.get('BillEmail') as FormGroup;
  }



  addLineItem() {
    if (this.lineItems.invalid) {
      this.lineItemSubmitted = true;
      return;
    }
    this.lineItems.push(this.createLineItem());
    this.lineItemSubmitted = false;
  }

  removeLineItem(index: number) {
    this.lineItems.removeAt(index);
  }

  getInvoiceId() {
    this.invoiceServices.getInvoiceById(this.invoiceId).subscribe((data: any) => {
      if (data) {
        this.selectedCompany = data.company;

        if (this.selectedCompany) {
          this.getAllCustomers();
          this.getProductItems();
        }
        // Patch customer
        this.invoiceForm.patchValue({
          CustomerRef: { value: data.CustomerRef?.value || '' },
          DueDate : data.DueDate
        });
        this.invoiceForm.get('reference')?.patchValue({
          ...data.reference
        })
        this.invoiceForm.get('BillEmail')?.patchValue({
          Address : data.BillEmail.Address
        })
        // Patch line items
        const lineItems = this.invoiceForm.get('Line') as FormArray;
        lineItems.clear();
        data.Line.pop();
        data.Line.forEach((line: any) => {
          const lineItem = this.createLineItem();
          lineItem.patchValue(line);
          lineItems.push(lineItem);
        });
      }
    });
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
      }
    })
  }

  onSave() {
    this.submitted = true;
    this.lineItemSubmitted = true;
    if (!this.selectedCompany || this.invoiceForm.invalid) return;

    const customerId = this.invoiceForm.value.CustomerRef.value;

    const payload = {
      ...this.invoiceForm.value,
      TxnDate: this.invoiceForm.value.TxnDate || new Date().toISOString(),
      CustomerRef: { value: customerId },
      company: this.selectedCompany
    };
    
    this.invoiceServices.saveInvoice(this.invoiceId, payload).subscribe(
      {
      next:(data)=>{
        if(data){
          this.router.navigateByUrl('/invoices');
        }
      },
      error: (err) => {
        sweetAlert("Error", err, "error", "Ok");
      },
      complete: () => {
        console.log("Invoice save completed");
      }
    }
  )
  }


  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }

  get form() {
    return this.invoiceForm.controls
  }

  getAllCustomers() {
    this.customers = null;
    let queryParams = {
      limit: 9999,
      company: this.selectedCompany ? this.selectedCompany : ''
    }
    this.customerService.getCustomers(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.customers = data.results
          this.preCustomers = this.customers.reduce((obj: any, item: any) => {
            obj[item.id] = item;
            return obj;
          }, {});
        }
      })
  }

  getProductItems(){
    let queryParams = {
      limit: 9999,
      company : this.selectedCompany ? this.selectedCompany : ''
      // page,
    }
    this.productService.getProductServices(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.productItems = data.results
          this.productItems = this.productItems.filter((item:any)=>{
              return  ['NonInventory','Service'].includes(item.Type)
          })

        }
      })
  }

  getCompanies() {
    this.companyService.getCompanies({status:'created'}).subscribe((data: any) => {
      if (data) {
        this.companies = data.results
      }
    })
  }

  onCompanyChange(){
    if(this.selectedCompany){
      this.getAllCustomers();
      this.getProductItems();
    }
  }

onServiceSelect(event: Event, index: number) {
  const selectedId = (event.target as HTMLSelectElement).value;
  const selectedProduct = this.productItems.find((p: any) => p.Id === selectedId);
  console.log('selectedProduct', selectedProduct);

  if (selectedProduct) {
    const salesDetail = this.lineItems.at(index).get('SalesItemLineDetail') as FormGroup;

    // ✅ Patch Sku and UnitPrice
    salesDetail.get('Sku')?.patchValue(selectedProduct.Sku || 0);
    salesDetail.get('UnitPrice')?.patchValue(selectedProduct.UnitPrice || 0);

    // ✅ Recalculate Amount based on Qty × UnitPrice
    const qty = parseFloat(salesDetail.get('Qty')?.value) || 0;
    const unitPrice = parseFloat(selectedProduct.UnitPrice) || 0;
    const amount = qty * unitPrice;

    // ✅ Update Amount in parent group
    this.lineItems.at(index).get('Amount')?.patchValue(amount);
  }
}



onCustomerSelect(event: Event) {

  const selectedCustomerId = (event.target as HTMLSelectElement).value;

  const selectedCustomer = this.customers.find((c: any) => c.Id === selectedCustomerId);
  
  if (selectedCustomer) {
    const email = selectedCustomer?.PrimaryEmailAddr?.Address || '';
    this.invoiceForm.get('BillEmail.Address')?.patchValue(email);
  } 
  else {
    this.invoiceForm.get('BillEmail.Address')?.patchValue('');
  }
}

onQtyChange(index: number) {
  const lineGroup = this.lineItems.at(index) as FormGroup;
  const salesDetail = lineGroup.get('SalesItemLineDetail') as FormGroup;

  const qty = parseFloat(salesDetail.get('Qty')?.value) || 0;
  const unitPrice = parseFloat(salesDetail.get('UnitPrice')?.value) || 0;
  const amount = qty * unitPrice;

  lineGroup.get('Amount')?.patchValue(amount);
}


}
